
import React from 'react';
import { useSelector } from 'react-redux';

import Table from 'components/Table';

import {
  getAnovaConfidenceInterval,
  getTableStat,
  getQForStudentizedRangeDistribution,
  getTableForTukeyKramerPostHocAnalysis
} from 'store/scenes/inferentialStatistics/selectors';

import { significantFigures7AndFormatValue } from 'utilities/math';

const getTableHeadersForPostHocAnalysis = ['Factor', 'Mean'];

export const PostHocAnalysis = () => {
  const tableDataStat = useSelector(state => getTableStat(state));
  const confidenceInterval = useSelector(state => getAnovaConfidenceInterval(state));
  const qForStudentizedRangeDistribution = significantFigures7AndFormatValue(useSelector(state => getQForStudentizedRangeDistribution(state)));
  const tableForTukeyKramerPostHocAnalysis = useSelector(state => getTableForTukeyKramerPostHocAnalysis(state));

  const tableData = tableDataStat.map(report => [report[0], report[2]]);

  return (
    <div className="content-item">
      <h2>Tukey-Kramer Post Hoc Analysis at {confidenceInterval}% Confidence Interval</h2>
      <table className="infStatMarkup-table">
        <tbody>
          {tableForTukeyKramerPostHocAnalysis.map(str => (
            <tr key={str[0]}>
              <td>{str[0]} Interval:</td>
              <td>{str[1]}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <h3>q= {qForStudentizedRangeDistribution}</h3>
      <div className="max-600">
        <h3>Summary Statistics by Factor</h3>
        <Table tableHeaders={getTableHeadersForPostHocAnalysis} tableData={tableData} />
      </div>
    </div>
  );
};
